// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Qtp6wUNz93IGjGDt2Nsg {
  padding-top: 24px;
}

/* The !importants below are because of legacy-bs-override */
.ZX6R8gRk421DAmMTb32y {
  margin-left: 16px !important;
}

.ZX6R8gRk421DAmMTb32y:hover {
  color: white !important;
}

.PfBlNW9ZETFmXG9nO96b input[type=number] {
  font-weight: 400 !important;
  width: 100px;
}

.prJq1cu6gKB7YZCkz_pQ {
  padding: 3px;
  border: 1px solid rgb(196, 195, 196);
  border-radius: 4px;
}`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/interests/interests-table/pagination.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA,4DAA4D;AAC5D;EACE,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;AACpB","sourcesContent":[".container {\n  padding-top: 24px;\n}\n\n/* The !importants below are because of legacy-bs-override */\n.jumpButton {\n  margin-left: 16px !important;\n}\n\n.jumpButton:hover {\n  color: white !important;\n}\n\n.jumpInput input[type=number] {\n  font-weight: 400 !important;\n  width: 100px;\n}\n\n.paginationBorder {\n  padding: 3px;\n  border: 1px solid rgb(196, 195, 196);\n  border-radius: 4px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Qtp6wUNz93IGjGDt2Nsg`,
	"jumpButton": `ZX6R8gRk421DAmMTb32y`,
	"jumpInput": `PfBlNW9ZETFmXG9nO96b`,
	"paginationBorder": `prJq1cu6gKB7YZCkz_pQ`
};
export default ___CSS_LOADER_EXPORT___;
